const APP = '/';

export const app = {
  base: `${APP}`,
  logout: '/logout',
  unauthorized: '/403',
  notFound: '/not-found',
  smartZone: '/smart-zone',
  satV1Zone: '/sat-v1-zone',
  satV2Zone: '/sat-v2-zone',
  satV3Zone: '/sat-v3-zone',
  satV4Zone: '/sat-v4-zone',
  satV5Zone: '/sat-v5-zone',
};

export function toRelativePath(absolutePath: string, baseName = ''): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    // Remove the baseName portion
    relative = absolutePath.substring(baseName.length);
  }

  // If there's a leading '/', strip it out so the returned path doesn't start with '/'
  return relative?.startsWith('/') ? relative.substring(1) : relative;
}
